
<v-form ref="form" class="w-100" v-if="item">
    <v-container fluid class="pa-0">
        <v-row class="no-frame">
            <v-col >
                <f-title :title="$t('inb.detail.head.title')" />
                <c-inb-context
                    :item          = "item"
                    :confirm-morph = "false"
                    :force-morph   = "true"
                    ref            = "siteselect"
                    @morph         = "onMorph"
                    @changed       = "onContext"
                />
            </v-col>

            <v-col >
                <f-title title="Inhalt" class="mt-0" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <div>
                            <v-text-field
                                label="Betreff"
                                v-model = "item.subject"
                                :rules  = "[requiredRule]"
                            />
                        </div>
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <div>
                            <v-text-field
                                label   = "Gemeldet von"
                                v-model = "item.reporter"
                                :rules  = "[requiredRule]"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</v-form>
